/* eslint-disable camelcase */
export default {
	// 商户号首页开始
	welcome: '欢迎您，',
	home_left_notice: '专业 / 诚信 / 卓越',
	todo: '待办',
	logout: '退出',
	version_switch: '切换新版',
	// 快捷入口

	merchant_management: '经费管理',
	merchant_query: '经费查询',
	merchant_apply: '经费申请',
	subject_query: '主体资质查询',
	merchant_qualification_management: '资质管理',
	subject_entry: '主体信息录入',
	merchant_certificate_management: '证书密钥管理',
	certificate_apply: '证书密钥申请',
	authorization_letter_management: '法代授权函管理',
	authorization_letter_query: '授权函新增和查询',

	// 待办
	approval_todo: '审批待办',
	merchant_apply_waiting_for_approval: '商户号开立待审核',
	merchant_right_change_for_approval: '商户号权限变更待审核 ',
	merchant_info_change_for_approval: '商户号信息变更审核 ',
	merchant_logout_for_approval: '商户号注销待审核',

	// 统计图
	merchant_account_spending_statistics: '商户号开销数量统计',
	proportion_of_merchant: '商户号总量分类占比',

	// 其他
	system_guidelines: '系统指引',
	feedback: '咨询反馈',
	financial_system_qa: '财务制度答疑',
	wired_finance_1: '连线财经1',
	purchasing_business_qa: '采购业务答疑',
	it_system_support: 'IT系统支持',
	it_hotline: 'IT热线-财经系统支持',
	oa_home: 'OA首页',
	gmmp: '供应商门户',
	look_more: '查看更多',

	// 商户号首页结束

	system_name: '系统名称',
	category: '类别',
	configuration_value: '配置值',
	Whether_to_enable: '是否启用',
	category_code: '类别代码',
	value_code: '值的代码',
	the_name_of_the_value: '值的名称',
	sort: '排序',
	remark: '备注',
	operate: '操作',
	confirm: '确认',
	Cancel: '取消',
	Revise: '编辑',
	delete: '删除',
	add: '添加',
	enable: '启用',
	rule_type_code: '规则类型编码',
	rule_type_name: '规则类型名称',
	configure_encoding: '配置编码',
	configuration_name: '配置名称',
	configuration: '配置',
	priority: '优先级',
	last_modified_by: '最后修改人',
	disabled: '禁用',
	rule_description: '规则描述',
	inquire: '查询',
	please_enter: '请输入',
	consultation_feedback: '咨询&反馈',
	current_account: '当前账户',
	user_roles: '角色',
	permission: '功能权限',
	edit_or_create: '录入/修改',
	account_info: '账户信息',
	super_admin_info_edit_title: '超级管理员信息录入/修改'
};
